import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { environment } from '@environments/environment';
import { AuthAppRedirectService } from '@services/auth-app-redirect.service';

// Pages still linked from emails already sent, served by the auth app under another path.
const AUTH_APP_PATHS = new Map([
  ['register', '/register'],
  ['reset-password', '/password/reset'],
]);

/** The former `/user/*` auth pages now live in the auth app: forward there, any other page goes to its login. */
export const legacyUserRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authAppRedirectService = inject(AuthAppRedirectService);
  const page = route.firstChild?.url[0]?.path;
  const authAppPath = AUTH_APP_PATHS.get(page);
  const { intentUrl, ...queryParams } = route.queryParams;
  const isShareInvitation = page === 'register' && !!queryParams.token;

  if (isShareInvitation) {
    // The auth app knows nothing about shares: sign up (or log in) there, then the webapp claims it.
    const sharedToMeUrl = `${environment.appUrl}/sharedtome?shareToken=${encodeURIComponent(queryParams.token)}`;
    authAppRedirectService.forward('/register', { redirect_uri: sharedToMeUrl });
  } else if (page === 'reset-password-request') {
    authAppRedirectService.forward(
      '/password/forgot',
      queryParams.mailAddress ? { email: queryParams.mailAddress } : {},
    );
  } else if (authAppPath) {
    authAppRedirectService.forward(authAppPath, queryParams);
  } else {
    // An explicit return URL: by default `login()` would come back to this very `/user/*` URL.
    authAppRedirectService.login(intentUrl ?? '/home');
  }
  return false;
};
